<script lang="ts">
	import { formatNumberWithSeparators } from "../../../../functions";
	import SedeCapComuneDipendente from "../../../../models/Sede/CapComuneDipendente";

    export let data: SedeCapComuneDipendente = new SedeCapComuneDipendente();
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">CAP</th>
            <th class="border border-black">Città</th>
            <th class="border border-black">Numero di dipendenti domiciliati</th>
        </tr>
    </thead>
    <tbody>
        {#if data?.indirizzi?.length > 0}
            {#each data.indirizzi as indirizzo}
                <tr>
                    <td class="text-center border border-black">{indirizzo?.cap}</td>
                    <td class="text-center border border-black">{indirizzo?.comune}</td>
                    <td class="text-center border border-black">{formatNumberWithSeparators(indirizzo?.numeroDipendentiDomiciliati)}</td>
                </tr>
            {/each}
        {:else}
            <td class="text-center bg-blue-100 border border-black">-</td>
            <td class="text-center bg-blue-100 border border-black">-</td>
            <td class="text-center bg-blue-100 border border-black">-</td>
        {/if}
    </tbody>
</table>